import { useMutation } from '@tanstack/react-query';
import { type IncomingHttpHeaders } from 'http';

import { carValuationApi } from 'api/carValuationApi';

import {
  PrivateValuation,
  privateValuationResponseSchema,
} from '../schema/PrivateValuationSchema';

import { formatAuthorizationHeader } from 'helpers/auth';
import { useAuthOptions } from 'hooks/useAuthOptions';

import { PAGE } from 'helpers/pages';

const getCarValuation = async ({
  registrationNumber,
  mileageInKilometers,
  headers,
}: {
  registrationNumber: string;
  mileageInKilometers: string;
  headers: IncomingHttpHeaders;
}): Promise<PrivateValuation> => {
  const { data } = await carValuationApi.postCarValuation({
    registrationNumber,
    mileageInKilometers,
    headers,
    source: PAGE.AD_DETAILS,
  });

  return privateValuationResponseSchema.parse(data);
};

export const useGetCarValuation = () => {
  const { accessToken } = useAuthOptions();

  const headers = formatAuthorizationHeader(accessToken);

  return useMutation({
    mutationFn: (args: {
      registrationNumber: string;
      mileageInKilometers: string;
    }) =>
      getCarValuation({
        ...args,
        headers,
      }),
    meta: { noToast: true, tags: [PAGE.AD_DETAILS] },
  });
};
